import React, { useState, useRef, useEffect } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { text_to_speech } from '../../helpers/url_helper';
import config from '../../config';
import {remark} from 'remark'
import strip from 'strip-markdown'

const HandleSpeech_Button = ({ text }) => {
  const [toggleSpeakButton, setToggleSpeakButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const audioRef = useRef(null); // Ref to store the audio object
  const [baseURL, setBaseURL] = useState('');

  useEffect(() => {
    if (window.location.hostname === 'localhost') {
      setBaseURL(config.api.API_URL_LOCAL_HOST);
    } else {
      setBaseURL(config.api.API_URL);
    }
    if (!text) {
      // setError('Please enter some text.');
      return;
    }
  }, [text]);

  const handleSynthesize = async () => {
    setError(null);
    setIsLoading(true);

   
    let text_after_markdown_removal =String( await remark()
  .use(strip)
  .process(text))
    

    try {
      const response = await fetch(baseURL + text_to_speech, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text:text_after_markdown_removal})
    
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to synthesize speech.');
      }

      const audioBlob = await response.blob();
      const audioUrl = URL.createObjectURL(audioBlob);

      // Create an audio object and play the stream
      if (audioRef.current) {
        audioRef.current.src = audioUrl;
        audioRef.current.play();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset to the beginning
    }
  };

  const handleAudioEnd = () => {
    setToggleSpeakButton(true); // Reset the button to "Speak" after audio ends
  };

  useEffect(() => {
    // Listen for the 'ended' event on the audio element
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', handleAudioEnd);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleAudioEnd);
      }
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <Button id="play" className="btn rounded-pill" color="primary" disabled>
          <i className="ri-loader-2-line ri-spin"></i> Loading...
        </Button>
        
        
      ) : (
        <>
        <Button id='play'
          onClick={() => {
            if (toggleSpeakButton) {
              handleSynthesize();
            } else {
              handleStopAudio();
            }
            setToggleSpeakButton(!toggleSpeakButton);
          }}
          className="btn rounded-pill"
          color="primary"
          >
          <i  className={toggleSpeakButton ? 'ri-play-mini-line' : 'ri-stop-mini-line'}></i>
          {/* {toggleSpeakButton ? 'Speak' : 'Stop'} */}
        </Button>
            <UncontrolledTooltip    placement="left"
                                      target="play"
                                      className="leftmore"
                                      id="play">
         Play Text
        </UncontrolledTooltip></>
          
        
      )}
      {error && <p>{error}</p>}
      <audio ref={audioRef} />
    </>
  );
};

export default HandleSpeech_Button;
